/**
 * Route for `igaming-tiered`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingTieredPage } from "../features/igaming-tiered/IgamingTieredPage";

export const igamingTieredRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-tiered",
	component: IgamingTieredPage,
});

export default igamingTieredRoute;
